// get all messages
export const getAllMessages = (id) => ({
  url: `/chats/get-messages/${id}`,
  method: "GET",
});

// send message
export const sendMessage = (body) => ({
  url: `/chats/send-message/`,
  method: "POST",
  body,
});

//get images
export const getImages = (id) => ({
  url: `/chats/get-images/${id}`,
});

export const approveMsg = (body) => ({
  url: '/admin/approve-msg',
  method: "POST",
  body,
})

// toggle activation of user account
//   export const toggleActivation = (id) => ({
//     url: `/admin/user-status/${id}`,
//     method: "POST",
//   });
